import React from 'react';

import { Box, Typography } from '@mui/material';

import { departureActionDefinitions } from './departureActions';
import { hasReviewStatuses, reviewStatuses } from './reviewLogic';
import type { CommandDeparture } from './types';

const descriptions = {
  Urgent: 'Financial risk, handback within 90 days.',
  'Needs Action': 'A known issue needs a decision.',
  'Assessment Incomplete': 'Some information is missing.',
  Watch: 'A small traveller shortfall.',
  Monitor: 'Too early to act.',
  'On Track': 'No issue found.',
  Final: 'Handback has passed.',
  'Not in review': 'Closed or hidden, with no bookings.',
};

export default function ActionDefinitions({ rows = [] }: { rows?: Array<CommandDeparture> }) {
  const definitions = hasReviewStatuses(rows)
    ? reviewStatuses.map((label) => ({ label, description: descriptions[label] }))
    : departureActionDefinitions.filter(({ flag }) =>
        ['red', 'amber', 'green', 'empty', 'early', 'handed back'].includes(flag),
      );
  return (
    <Box
      aria-label="Departure status key"
      sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(2, minmax(0, 1fr))' }, gap: 0.5, my: 2 }}
    >
      {definitions.map(({ label, description }) => (
        <Typography key={label} variant="caption">
          <Box component="span" sx={{ fontWeight: 700 }}>
            {label}:
          </Box>{' '}
          {description}
        </Typography>
      ))}
      <Typography variant="caption" color="text.secondary" sx={{ gridColumn: '1 / -1' }}>
        With no bookings yet, forecast is indicative.
      </Typography>
    </Box>
  );
}
